/**
 * @copyright       Palace Resorts
 * @description     Mensajes para registro de facturas
 * @author          Leticia Beltrán
 * @creationDate    26/08/2021
 */

 import _ from "lodash";
 import appMessages from "@/i18n/app.messages";
 
 let moduleMessages = {
     messages: {
         ESP: {
             lblTitle: "Subcontratación",
             lblsubtitle:"Factura",
         },
         ENG: {
             lblTitle: "Outsourcing",
             lblsubtitle: "Invoice",
         },
     },
 };
 
 export default _.merge(moduleMessages, appMessages);